// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module--header--2-TZJ","header__title":"styles-module--header__title--ik4Lg","header__description":"styles-module--header__description--25d4B"};